/**
 * https://www.html-code-generator.com/javascript/shorten-long-numbers
 * @description Converts numbers to a string containing a magnitude suffix.
 * @example 9,000,000,000 -> 9B
 * @example 1,000,000 -> 1M
 */
export function abbreviatedNum(n: number): string {
  if (n < 1000) return n.toString().replace(/[^\d.]/g, "");

  const si = [
    { v: 1e3, s: "K" },
    { v: 1e6, s: "M" },
    { v: 1e9, s: "B" },
    { v: 1e12, s: "T" },
    { v: 1e15, s: "P" },
    { v: 1e18, s: "E" },
  ];
  let index;
  for (index = si.length - 1; index > 0; index--) {
    if (n >= si[index].v) {
      break;
    }
  }
  return (
    (n / si[index].v).toFixed(2).replace(/\.0+$|(\.\d*[1-9])0+$/, "$1") +
    si[index].s
  );
}
